export enum UserCenterRoute {
  Root = "/",
  Profile = "/profile",
  Payment = "/payment",
  ChildCustomer = "/childCustomer",
  Project = "/project",
  Coupon = "/coupon",
  TopUp = "/topUp",
  Invoice = "/invoice",
  InvoicePrevious = "/invoice/previous",
  ExportList = "/exportList",
  OperateRecord = "/operateRecord",
  Consumption = "/consumption",
  ConsumptionPrevious = "/consumption/previous",
  MessageCenter = "/message/center",
  Developer = "/developer",
  InviteRewards = "/inviteRewards",
  ClientTopUp = "/clientTopUp",
}

export const UserCenterRouteList = Object.values(UserCenterRoute);
